<template>
  <v-speed-dial
    v-model='isOpen'
    :top="top"
    :bottom="bottom"
    :right="right"
    :left="left"
    :direction="direction"
    :open-on-hover="hover"
    :transition="transition"
    :class="classes"
    absolute
  >
    <template #activator>
      <w-btn
        class="logo"
        fab
      >
        <w-icon
          color="var(--v-accent-base)"
          size="3.125rem"
        >
          $wWork
        </w-icon>
      </w-btn>
    </template>
    <slot
      name='default'
      :open='isOpen'
    />
  </v-speed-dial>
</template>

<script>
export default {
  name: 'WorkSpeedDial',
  props: {
    direction: { type: String, default: 'top' },
    hover: { type: Boolean, default: false },
    top: { type: Boolean, default: false },
    right: { type: Boolean, default: true },
    bottom: { type: Boolean, default: true },
    left: { type: Boolean, default: false },
    transition: { type: String, default: 'slide-y-reverse-transition' },
    breakpoint: { type: String, default: 'sm' }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    classes() {
      return `d-flex d-${this.breakpoint}-none w-speed-dial`;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-speed-dial__list {
  padding: 0.375rem 0rem;
  .v-btn {
    box-shadow: $box-shadow;
    background-color: var(--v-window-base) !important;
    &--default {
      color: $button-color !important;
    }
  }
}

.w-speed-dial {
  position: fixed;
}

.w-speed-dial .v-btn,
::v-deep .v-speed-dial__list .v-btn--icon {
  height: 3.125rem !important;
  width: 3.125rem !important;
}
</style>
